import "dayjs/locale/en";
import "dayjs/locale/it";
import {
	VevyLibrary,
	vevyLibrary_locales_en,
	vevyLibrary_locales_it,
} from "react-vevy-library";
import settings from "../settings.json";

import passepartout_locales_en from "../locales/passepartout_en.json";
import passepartout_locales_it from "../locales/passepartout_it.json";

import {
	keycloak_locales_en,
	keycloak_locales_it,
} from "react-keycloak-manager";

import {
	NotificationManager_locales_en,
	NotificationManager_locales_it,
} from "react-notifications-manager";

import Home from "./Home";

const translations = {
	it: [
		passepartout_locales_it,
		vevyLibrary_locales_it,
		keycloak_locales_it,
		NotificationManager_locales_it,
	],
	en: [
		passepartout_locales_en,
		vevyLibrary_locales_en,
		keycloak_locales_en,
		NotificationManager_locales_en,
	],
};

function App() {
	return (
		<div data-color-mode='light'>
			<VevyLibrary
				settings={settings}
				translations={translations}
				syncLanguageChange={false}
			>
				<Home />
			</VevyLibrary>
		</div>
	);
}

export default App;
